import {makeAutoObservable} from "mobx";

export class Magazine {
  //#region defaultProperties
  readonly briefDescription: string
  readonly countryOfOrigin: string
  readonly coverPrice: number
  readonly coverPriceDisplay: string
  readonly ean: string
  readonly frequency: number
  readonly id: number
  readonly nextIssue: string
  readonly publisherId: number
  readonly title: string
  readonly titleDisplay: string
  readonly weight: number
  readonly stockistMagazineUrl: string
  //#endregion

  //#region customProperties
  // #endregion

  constructor(
    data: {
      briefDescription: string,
      countryOfOrigin: string,
      coverPrice: number,
      coverPriceDisplay: string,
      ean: string,
      frequency: number,
      id: number,
      nextIssue: string,
      publisherId: number,
      title: string,
      titleDisplay: string,
      weight: number,
      stockistMagazineUrl: string
    }) {

    this.briefDescription = data.briefDescription
    this.countryOfOrigin = data.countryOfOrigin
    this.coverPrice = data.coverPrice
    this.coverPriceDisplay = data.coverPriceDisplay
    this.ean = data.ean
    this.frequency = data.frequency
    this.id = data.id
    this.nextIssue = data.nextIssue
    this.publisherId = data.publisherId
    this.title = data.title
    this.titleDisplay = data.titleDisplay
    this.weight = data.weight
    this.stockistMagazineUrl = data.stockistMagazineUrl ?? `/magazine/${this.id}-magazine` 
    makeAutoObservable(this)
  }
}